$ = jQuery;

var delay = (function () {
     var timer = 0;
     return function (callback, ms) {
       clearTimeout(timer);
       timer = setTimeout(callback, ms);
     };
})();

//Print page -> blog
var Page = {
     printPage: function () {
         $( document ).on( 'click', '#printPage', function (e) {
             e.preventDefault();
             window.print();
         });
     }
};

// Go back previous page - single reference
var previous = {
     page: function () {
         $('.tag__reference--link-js').on( 'click', function (e) {
             e.preventDefault();
             location.href = document.referrer;
             return false;
         });
     }
};

// Checkbox checked
var Checkbox = {
     check: function () {
          $inputCheckbox = $('form.wpcf7-form input[type=checkbox]');
          $inputSubmit = $('for.wpcf7-form input[type=submit]');

          $inputCheckbox.on('click', function() {
               var checkoxCheck = $(this).prop('checked');
               if (checkoxCheck) {
                    $(this).addClass('checked');
               }
               else {
                    $(this).removeClass('checked');
               }
          });

          if ($inputSubmit.attr('disabled', true)) {
               $inputCheckbox.removeClass('checked');
          }



          $('.wrapper__form form input[type=submit]').on('click', function() {
          var checkExist = setInterval(function() {
               var attrValForm = $('.wrapper__form form').attr('data-status') === 'sent';
               if ( attrValForm ) {
                    clearInterval(checkExist);
                    $('.wrapper__form form .gdpr input[type=checkbox]').removeClass('checked');
               }
               }, 100); // check every 100ms
          });
     }
};

// Smoothscroll
var Smooth = {
     scroll: function () {
          $('a[href*="#"]').not('.tabs a').not('.menu-item-has-children a').on('click', function() {
               var the_id = $(this).attr('href').split('#')[1];
               $('html, body').animate({
               scrollTop: $('#' + the_id).offset({ top : -150 })
          }, 'slow');
               return false;
          });
     }
};



//  Disable first option form
var Disable = {
     option: function () {
          $( '.wpcf7-form option:first-child').prop( 'disabled', true);
     }
};


var MenuHeader = {
     overlay: function () {
          var btnMenu = $('.navbar-toggler');
          btnMenu.on('click', function() {
               $('#navbar__menu, .navbar-toggler-icon').toggleClass('show');
               window.onresize = function (event) {
                    delay(function() {
                         if ($(window).width() < 768 ) {
                              $('.wrapper__lang').toggleClass('show');
                         }
                    }, 300);
               }
          });
     }
}


//  Pagination blog
var Pagination = {
     blog: function () {
          $('.screen-reader-text').remove();
          $('.blog__pagination--list .nav-links').addClass('d-flex');
          $('.blog__pagination--list a.next, .blog__pagination--list a.prev').addClass('pagination--picto').empty();
     }
};


// Page animation shémas machines-infos
var machine = {
     animation: function() {
          $('.btn__encart').on('click', function() {
               // Remove all class 'active' 
               $('.encart').removeClass('active');
               $(this).next().addClass('active');
          });
     }
}


//  SubMenu
var Menu = {
     submenu: function () {
          if ( $('li').hasClass('menu-item-has-children') ) {
               $( '<button class="btn_sub-menu"></button>' ).insertAfter( ".menu-item-has-children > a" );
           }
       
          var navList = $('#menu-menu-header-1');
          var subMenu = $('.menu-item-has-children > a[href="#"], .btn_sub-menu');

          // open submenu on click
          subMenu.on('click', function(e) {
               e.preventDefault();

               var targetBtn = '';
               if($(this).hasClass('btn_sub-menu')) {
                    targetBtn = $(this);
               } else {
                    targetBtn = $(this).next();
               }
               targetBtn.toggleClass('open');
               navList.find('.open_submenu').not(this).parent().not(this).next().removeClass('open_submenu open');
               $(this).siblings('.sub-menu').toggleClass('open_submenu');

               return false;
          });
     }
};


var Blog = {
     categoryFilter: function () {
          $('.wrapper__blog .category--link').on('click', function(event) {
               event.preventDefault();
               $('.wrapper__blog .category--link').removeClass('active');
               $(this).addClass('active');
             
               $.ajax({
                 type: 'POST',
                 url: MYSCRIPT.ajaxUrl,
                 dataType: 'html',
                 data: {
                   action: 'filter_posts',
                   category: $(this).data('id'),
                 },
                 success: function(res) {
                   $('.blog__listing').empty();
                   $('.blog__listing').html(res);
                   $('.navigation.pagination').remove();
               //     $('.blog__listing').after(res);
                 }
               })
          });
     }
}

// anchor link on banner page
var Anchor = {
     banner: function () {
          $idLinkAnchor        = $('#link--banner-page');
          $firstDivClass       = $('.block__select_js:first-child');
          
          $idLinkAnchor.on('click', function(e) {
               e.preventDefault();
               $idDestination = $firstDivClass.attr('id');
               $('html, body').animate({
                    scrollTop: $('#' + $idDestination).offset().top + 160
               }, 'slow');
          });
     }
}


  
// Trigger animation on scroll
var doAnimations = function() {
     // Calc current offset and get all animatables
     var offset = $(window).scrollTop() + $(window).height(),
     $animatables = $('.animatable');
     
     // Unbind scroll handler if we have no animatables
     if ($animatables.length == 0) {
          $(window).off('scroll', doAnimations);
     }
     
     // Check all animatables and animate them if necessary
     $animatables.each(function(i) {
          var $animatable = $(this);
          if (($animatable.offset().top + $animatable.height() - 20) < offset) {
               $animatable.removeClass('animatable').addClass('animated');
          }
     });
};


//  Counter
var Counter = {
     number: function () {
          var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.count_animatable');
          
          // Unbind scroll handler if we have no animatables
          if ($animatables.length == 0) {
               $(window).off('scroll', Counter.number);
          }

          // Check all animatables and animate them if necessary
          $animatables.each(function(i) {
               let animatable = $(this);
               if ((animatable.offset().top + animatable.height() - 20) < offset ) {
                    animatable.removeClass('count_animatable').addClass('count_animated');
                    animatable.prop('Counter',0).animate({
                         Counter: animatable.text()
                         }, {
                              duration: 4000,
                              easing: 'swing',
                              step: function (now) {
                                   animatable.text(Math.ceil(now));
                              },
                              complete: function() {
                                   animatable.stop(true, true);
                              }
                         }
                    );
               }
          });
     }
};

  
// Hook doAnimations on scroll, and trigger a scroll
// $(window).trigger('scroll');
$(window).on('scroll', function(){
     doAnimations();
     Counter.number();
});



$(document).ready(function () { 
     Page.printPage();
     Checkbox.check();
     Disable.option();
     Pagination.blog();
     Menu.submenu();
     Anchor.banner();
     // Smooth.scroll();
     Blog.categoryFilter();
     MenuHeader.overlay();
     previous.page();
     machine.animation();

     // Check ACF
     if(typeof acf === 'undefined')
     return;
      // Date picker & Google Maps compatibility
      $('.acf-google-map input.search, .acf-date-picker input.input').addClass('form-control');
      
      // Clean errors on submission
      acf.addAction('validation_begin', function($form){
           $form.find('.acf-error-message').remove();
      });
      
      // Add alert alert-danger & move below field
      acf.addAction('invalid_field', function(field){
           field.$el.find('.acf-notice.-error').addClass('alert alert-danger').insertAfter(field.$el.find('.acf-input'));
      });
});